import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'llaUtcToLocalDate',
  standalone: false
})
export class UtcToLocalDatePipe implements PipeTransform {
  transform(value: string | null | undefined): string | null {
    if (!value) {
      return null
    }
    const utcDateString = value.endsWith('Z') ? value : `${value}Z`
    const localDate = new Date(utcDateString)
    return localDate.toISOString()
  }
}
